



























import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import { MswRegisterProductTabRoute } from '@/modules/msw-products';
const cssPrefix = 'msw-register-widget';

@Component({
  components: {
    MswWidgetCard,
  },
})
export default class MswRegisterWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  routeToRegisterPage() {
    // Route to page and in future use the License expiry alerts filter
    window.parent.postMessage({
      redirectUrl : `/m/feature/${MswRegisterProductTabRoute.path}?redirectTo=workspace`,
    },                        '*');
    this.$router.push({ path: `/m/feature/${MswRegisterProductTabRoute.path}?redirectTo=workspace` });
  }
}
